// utils/authUtils.ts
import { User } from "firebase/auth";

export const getUserRoles = async (user: User): Promise<string[]> => {
    try {
      const idTokenResult = await user.getIdTokenResult();
      return (idTokenResult.claims.roles as string[]) || [];
    } catch (error) {
      console.error("Error getting user roles:", error);
      return [];
    }
  };

export const isSuperAdmin = (roles: string[]): boolean => {
  return roles.includes('super-admin');
};

// export const isAdmin = (roles: string[]): boolean => {
//   return roles.includes('admin') || isSuperAdmin(roles);
// };